import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { siteStatsBackend } from './site-stats.backend';
import { siteStatsReducer } from './site-stats.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('siteStats', siteStatsReducer),
    BackendModule.forFeature('siteStats', siteStatsBackend),
  ],
})
export class DatastoreSiteStatsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/site-stats/site-stats.module.ts